angular
    .module('tradersyard')
    .run([
        'graph-api-client',
        'graph-news-factory',
        function ($api, $factory) {
            $api.factory.news = $factory;
        },
    ])
    .factory('graph-news-factory', [
        'graph-api-client',
        'graph-post-factory',
        function (client, posts) {
            function news(entry, id) {
                var isPublic = entry === 'public';

                if (entry === 'user') entry = undefined;

                this.query = function (options) {
                    return client.get(isPublic ? ['public/feed'] : [entry, id, 'news'], options);
                };

                this.posts = function () {
                    return new posts.entry(entry, id);
                };
            }

            /**
             *  @type {String}
             */
            return {
                entry: function (entry, id, term) {
                    return new news(entry, id, term);
                },
            };
        },
    ]);
